import { render, staticRenderFns } from "./LoginExpired.vue?vue&type=template&id=5cadb9f2&"
import script from "./LoginExpired.vue?vue&type=script&lang=js&"
export * from "./LoginExpired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports